import { ContinueCard, useGoTab } from "./ContinueCard";

const PRINT = [["ebook", "Ebook"], ["paperback", "Paperback"], ["hardcover", "Hardcover"]];

export const VersionsNext = ({ book, list }) => {
  const go = useGoTab();
  const v = list.find((x) => x.id === book.approved_version_id);
  if (!v) return null;
  const newer = book.current_version && book.current_version.number > v.number ? book.current_version.number : null;
  return <ContinueCard testId="versions-continue-card" title={`v${v.number} is approved`} text={newer ? `Editions use v${v.number}. Your newer v${newer} isn't approved yet — approve it in the table below to build from it.` : "Build your editions from this version."}
    actions={PRINT.map(([tab, label]) => ({ label: `Build ${label.toLowerCase()}`, onClick: () => go(tab), testId: `versions-continue-${tab}` }))} />;
};

export const BuiltNext = ({ book, edition }) => {
  const go = useGoTab();
  const ed = book.editions?.[edition] || {};
  if (ed.status !== "generated" || ed.outdated) return null;
  return <div className="xl:col-span-2"><ContinueCard testId={`${edition}-continue-card`} title="Edition built" text="Check everything is ready before you upload."
    actions={[{ label: "Run publishing check", onClick: () => go("preflight"), testId: `${edition}-continue-preflight` }]} /></div>;
};

export const PreflightNext = ({ book, overall }) => {
  const go = useGoTab();
  if (overall === "ERROR") return null;
  const live = book.showcase?.enabled;
  return <ContinueCard testId="preflight-continue-card" title={live ? "Your book is on your showcase" : "No blocking problems found"}
    text={live ? "Update its page, links or release date any time." : "Put it on your showcase so readers can find it."}
    actions={[{ label: live ? "Open showcase settings" : "Put it on your showcase", onClick: () => go("showcase"), testId: "preflight-continue-showcase" }]} />;
};
